(function(){
  'use strict';

  angular
    .module('app.products')
    .controller('ProductCategoryController', ProductCategoryController);

  function ProductCategoryController($state, API, $filter) {
    let vm = this;
		vm.listProducts = [];
		vm.listSubCategories = [];
		const slug = $state.params.slug;

		vm.$onInit = () => {
			if(slug.toUpperCase() == 'bras-x'.toUpperCase())
				$state.go('home');
			else
		  		_loadFromApi();
		}

		function _loadFromApi() {
		  _loadProducts();
		  _loadCategoriesProducts();
		}

		function _loadCategoriesProducts() {
	      API.get(`produto_brastelha/categoria`)
	        .then(result => result.data)
			.then(categories => vm.listSubCategories = categories.filter((el) => el.slug == slug)[0])
	        .catch(error => {
	          console.log(error, 'error');
	        });
	    }

		function _loadProducts() {
		  API.get(`produto_brastelha/categoria/${slug}`)
				.then(result => result.data)
				.then(products => vm.listProducts = products.map(product => {
          product.image = $filter('imgUrl')(product.img);
          return product;
        }))
        .then(console.log)
				.catch(error => {
				  console.log(error, 'error');
				});
		}
  }

})();
